// Raincode brand color system — dark theme tokens that mirror the CSS
// variables in core.css. Inline styles using these should render legibly
// against #0a1528 surfaces.
export const C = {
  bg:         "#04091a",
  sidebar:    "#1a2336",
  card:       "#0a1528",
  cardHov:    "#0e1c38",
  border:     "#14213d",
  borderMid:  "#1c2e52",
  text:       "#dce8f8",  // primary text on dark bg (matches --rc-text-primary)
  sub:        "#8fa4c8",  // secondary text (matches --rc-text-secondary)
  dim:        "#4a6a96",  // dim text (matches --rc-text-dim)
  // Raincode primary blue
  accent:     "rgb(64,117,193)",
  // Status colors — saturated enough to pop on the dark surface
  green:      "#10b981",  greenB: "rgba(16,185,129,.18)",
  yellow:     "#f59e0b",  yellowB:"rgba(245,158,11,.18)",
  red:        "#ef4444",  redB:   "rgba(239,68,68,.18)",
  blue:       "#60a5fa",  blueB:  "rgba(96,165,250,.18)",
  purple:     "#a855f7",  purpleB:"rgba(168,85,247,.18)",
};

export const AVATAR_COLORS = {
  MW:"rgb(64,117,193)", LP:"#a855f7", SC:"#10b981",
  KN:"#f59e0b", TR:"#ef4444", AO:"#06b6d4",
};

export const DEPT_COLORS = {
  "Sales":          { fg:"rgb(64,117,193)",  bg:"rgba(64,117,193,.12)"  },
  "Client Success": { fg:"#059669",          bg:"rgba(16,185,129,.12)"  },
  "Delivery":       { fg:"#d97706",          bg:"rgba(245,158,11,.12)"  },
  "Recruitment":    { fg:"#9333ea",          bg:"rgba(168,85,247,.12)"  },
  "Finance":        { fg:"#0891b2",          bg:"rgba(6,182,212,.12)"   },
  "Legal":          { fg:"#dc2626",          bg:"rgba(239,68,68,.12)"   },
  "Operations":     { fg:"#7c3aed",          bg:"rgba(139,92,246,.12)"  },
  "Engineering":    { fg:"#db2777",          bg:"rgba(236,72,153,.12)"  },
};
